import type {
  ArtistLinkPagePinnedAccess,
  ArtistLinkPagePopularSong,
  ArtistLinkPageSongItem,
} from "@libs/link-in-bio-config";

/** Apply page-owned artwork without changing the underlying music inventory. */
export function applySongArtwork(
  items: ArtistLinkPageSongItem[],
  overrides: Record<string, string> | undefined,
): ArtistLinkPageSongItem[] {
  if (!overrides) return items;
  const apply = (song: ArtistLinkPagePopularSong) =>
    overrides[song.id] ? { ...song, artworkUrl: overrides[song.id] } : song;
  return items.map((item) =>
    item.type === "song"
      ? { ...item, song: apply(item.song) }
      : {
          ...item,
          album: { ...item.album, tracks: item.album.tracks.map(apply) },
        },
  );
}

/** Keep featured music artwork consistent with its page-owned track artwork. */
export function applyPinnedMusicArtwork(
  access: ArtistLinkPagePinnedAccess,
  overrides: Record<string, string> | undefined,
): ArtistLinkPagePinnedAccess {
  if (access.type !== "music" || !overrides) return access;
  const songs = access.songs.map((song) =>
    overrides[song.id] ? { ...song, artworkUrl: overrides[song.id] } : song,
  );
  return {
    ...access,
    songs,
    imageUrl: overrides[songs[0]?.id ?? ""] ?? access.imageUrl,
  };
}
